export default function ServiceBlocks() {
  const services = [
    {
      title: 'Website Design & Development',
      description: 'Get a fast, mobile-first website that looks premium and converts visitors into customers. We build clean, modern sites that load quickly and work perfectly on every device.',
      included: [
        'Custom design tailored to your brand',
        'Mobile-responsive on all devices',
        'Fast loading speed optimization',
        'SEO-ready structure and metadata',
        'Contact forms and CTAs',
        'Google Analytics integration',
      ],
      image: 'https://public.readdy.ai/ai/img_res/662508ee4a0eddca87b949cc889c3f80.jpg',
    },
    {
      title: 'Local SEO Foundation',
      description: 'Get found by customers in your area. We optimize your online presence so you show up when people search for businesses like yours in Charleston and surrounding areas.',
      included: [
        'Google Business Profile setup and optimization',
        'Local keyword research and implementation',
        'Citation building across directories',
        'On-page SEO optimization',
        'Schema markup for local business',
        'Monthly performance reporting',
      ],
      image: 'https://readdy.ai/api/search-image?query=Digital%20marketing%20analytics%20dashboard%20on%20computer%20screen%20showing%20SEO%20metrics%20and%20local%20search%20rankings%2C%20clean%20modern%20interface%20with%20graphs%20and%20data%20visualization%2C%20professional%20business%20analytics%2C%20blue%20and%20white%20color%20scheme%2C%20contemporary%20digital%20marketing%20workspace%2C%20premium%20quality%20business%20technology&width=600&height=800&seq=service-002&orientation=portrait',
    },
    {
      title: 'Website Maintenance & Updates',
      description: 'Keep your site secure, fast, and up-to-date. We handle all the technical details so you can focus on running your business.',
      included: [
        'Secure hosting and SSL certificate',
        'Regular security updates and backups',
        'Content updates and changes',
        'Performance monitoring and optimization',
        'Technical support when you need it',
        'Monthly uptime and speed reports',
      ],
      image: 'https://readdy.ai/api/search-image?query=Website%20maintenance%20and%20security%20concept%20with%20laptop%20showing%20system%20updates%20and%20security%20shields%2C%20clean%20technical%20interface%2C%20professional%20IT%20workspace%2C%20modern%20digital%20security%20visualization%2C%20blue%20and%20gray%20color%20palette%2C%20contemporary%20technology%20aesthetic%2C%20premium%20quality%20business%20technology&width=600&height=800&seq=service-003&orientation=portrait',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {services.map((service, index) => (
          <div
            key={index}
            className={`flex flex-col ${
              index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
            } gap-12 items-center py-16 ${
              index !== services.length - 1 ? 'border-b border-gray-200' : ''
            }`}
          >
            <div className="lg:w-[60%]">
              <h2 className="font-sora font-bold text-4xl text-charcoal mb-6">
                {service.title}
              </h2>
              <p className="font-inter text-lg text-gray-600 leading-relaxed mb-8 max-w-[520px]">
                {service.description}
              </p>

              <div>
                <h3 className="font-inter font-semibold text-lg text-charcoal mb-4">
                  What's included:
                </h3>
                <ul className="space-y-3">
                  {service.included.map((item, idx) => (
                    <li
                      key={idx}
                      className="font-inter text-base text-gray-700 flex items-start gap-3"
                    >
                      <i className="ri-check-line text-primary text-xl mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="lg:w-[40%]">
              <div className="rounded-3xl overflow-hidden shadow-lg">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-[500px] object-cover"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}